abstract class Currency {

  public getCurrencyId(): number {
    return Object.getPrototypeOf(this).constructor.currencyId;
  }
}

export { Currency }
